import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Footer from 'src/components/Footer'
import NewHeader from 'src/New Codes/components/NewHeader'
import './PublicPages.css'
import './StaticPage.css'

const PILLARS = [
    {
        icon: 'fa-shield',
        title: 'Trust',
        text: "Every transporter is KYC-verified before they can bid on a load. Every account signs in with a one-time code sent to their email - no password to share. Every payment is held in escrow until delivery is confirmed.",
    },
    {
        icon: 'fa-map-marker',
        title: 'Visibility',
        text: 'A shipper should never have to wonder where their cargo is. Every job on Beba Mzigo is tracked from pickup to delivery, with photo and signature proof at both ends.',
    },
    {
        icon: 'fa-users',
        title: 'Fair access',
        text: "A transporter's fleet size shouldn't decide whether they get work. Beba Mzigo puts every verified transporter in front of the same pool of shippers, competing on price and reliability.",
    },
    {
        icon: 'fa-bolt',
        title: 'Speed',
        text: 'From posting a load to a transporter picking it up should take minutes, not days spent calling around. We built the bidding and self-assign tools to make that the norm.',
    },
]

const VISION_GOALS = [
    { icon: 'fa-map-o', title: 'Everywhere cargo moves', text: 'A load or a truck found in a few taps' },
    { icon: 'fa-shield', title: 'Trust built in', text: 'Verified, tracked and paid securely' },
]

const MISSION_POINTS = [
    "Verifying every transporter's identity before they can carry a shipper's cargo",
    'Giving shippers real-time visibility from pickup to delivery, not just a phone number to call',
    'Holding payment in escrow so a transporter is guaranteed to be paid, and a shipper only pays for a completed job',
    'Making it just as easy for a transporter to self-assign a nearby load as it is to bid on one',
]

const VisionMission = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = 'Vision & Mission | Beba Mzigo'
    }, [])

    return (
        <>
            <NewHeader />
            <div className="public-page sp-page">
                <header className="sp-hero" style={{ backgroundImage: "url('/assets/images/logistics-process.jpeg')" }}>
                    <div className="sp-hero-overlay"></div>
                    <div className="pp-wrap sp-hero-inner">
                        <span className="sp-hero-eyebrow">Vision &amp; Mission</span>
                        <h1>Every load, <span>moved on trust</span></h1>
                        <p>
                            We're building the platform we wished existed - the one that makes moving cargo
                            as easy as booking a ride.
                        </p>
                    </div>
                </header>

                <section className="pp-wrap sp-vm-grid">
                    <div className="sp-vm-card vision">
                        <div className="sp-vm-icon"><i className="fa fa-eye"></i></div>
                        <span className="sp-kicker light">Our vision</span>
                        <h2>The first place anyone thinks of to move goods</h2>
                        <p>
                            We want Beba Mzigo to be the first place a business thinks of when they need to move
                            goods - and the first place a truck owner checks when their vehicle is
                            free. A logistics network where finding a reliable transporter, or a paying load, is a
                            matter of a few taps, not a phone book of contacts built up over years.
                        </p>
                        <div className="sp-vm-goals">
                            {VISION_GOALS.map((goal) => (
                                <div className="sp-vm-goal" key={goal.title}>
                                    <i className={`fa ${goal.icon}`}></i>
                                    <div><strong>{goal.title}</strong><span>{goal.text}</span></div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="sp-vm-card mission">
                        <div className="sp-vm-icon"><i className="fa fa-bullseye"></i></div>
                        <span className="sp-kicker">Our mission</span>
                        <h2>Let strangers trust each other with a shipment</h2>
                        <p>
                            To connect shippers and transporters directly, with the verification, tracking and secure
                            payment tools that let two people who have never met trust each other. We do this by:
                        </p>
                        <ul className="sp-checklist">
                            {MISSION_POINTS.map((point) => (
                                <li key={point}><i className="fa fa-check"></i><span>{point}</span></li>
                            ))}
                        </ul>
                    </div>
                </section>

                <section className="sp-band">
                    <div className="pp-wrap">
                        <div className="sp-section-head">
                            <span className="sp-kicker">What we stand for</span>
                            <h2>Four principles behind every feature</h2>
                        </div>
                        <div className="vm-pillars">
                            {PILLARS.map((pillar) => (
                                <div className="vm-pillar" key={pillar.title}>
                                    <div className="vm-pillar-icon"><i className={`fa ${pillar.icon}`}></i></div>
                                    <h3>{pillar.title}</h3>
                                    <p>{pillar.text}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="pp-wrap">
                    <div className="sp-quote">
                        <i className="fa fa-quote-left"></i>
                        <p>Connecting shippers to transporters isn't just our tagline - it's the whole reason Beba Mzigo exists.</p>
                    </div>
                    <div className="sp-cta">
                        <div>
                            <h3>Be part of the network</h3>
                            <p>Join as a shipper or transporter and help move cargo on trust.</p>
                        </div>
                        <Link to="/signup" className="pp-btn">Get Started</Link>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    )
}

export default VisionMission
